import React from 'react';

import InventoryItemCard from './InventoryItemCard';
import WorkCard from './WorkCard';
import PlaceholderCard from './PlaceholderCard';

const WORK_TYPE = 'Work';
const INVENTORY_ITEM_TYPE = 'ihs_InventoryItemsItem';
const PLACEHOLDER_TYPE = 'Placeholder';

const COMPONENT_MAP = {
  [WORK_TYPE]: WorkCard,
  [INVENTORY_ITEM_TYPE]: InventoryItemCard,
  [PLACEHOLDER_TYPE]: PlaceholderCard
};

const FavoritableItemCard = props => {
  const { item } = props;
  const { __typename: type } = item || {};
  const CardComponent = COMPONENT_MAP[type];

  if (!CardComponent) return null;

  return <CardComponent {...props} />;
};

export const fragments = [
  {
    type: WORK_TYPE,
    name: WorkCard.displayName,
    fragment: WorkCard.fragment
  },
  {
    type: INVENTORY_ITEM_TYPE,
    name: InventoryItemCard.displayName,
    fragment: InventoryItemCard.fragment
  }
];

export default FavoritableItemCard;
